<template>
  <div class="contentDiv">
    <div class="cover scrollable-div">
      <HeaderContainer :active-index="currentMenuIndex" @menu-select="onMenuSelect"/>

      <el-row :gutter="20" style="margin-left: 0px; margin-right: 0px;width: 1170px">
        <!-- 大屏幕: 左侧30%/右侧70% -->
        <!-- 小屏幕: 堆叠显示 -->
        <el-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" style="padding: 0px">
          <div class="responsive-left">
            <!-- 左侧内容 -->
            <div class="widgets row5 coll">
              <div class="mybox hbox" id="help_box">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">關於 / {{title}}</div>
                  </div>
                </div>
                <div class="mybox_content">
                  <ul>
                    <li class="top"><a @click="showFun(1,'企業簡介')">企業簡介</a></li>
                  </ul>
                  <ul>
                    <li class="top"><a @click="showFun(2,'總裁致辭')">總裁致辭</a></li>
                  </ul>
                  <ul>
                    <li class="top"><a @click="showFun(3,'聯繫我們')">聯繫我們</a></li>
                  </ul>
                  <ul>
                    <li class="top"><a @click="showFun(4,'董事會')">董事會</a></li>
                  </ul>

                  <ul>
                    <li class="top"><a @click="showFun(5,'高級管理層')">高級管理層</a></li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="16" :lg="17" :xl="17" style="padding: 0px">
          <div class="responsive-right">
            <!-- 右侧内容 -->
            <!-- 關於 / 企業簡介 -->
            <div v-if="dialogVisible==1" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">關於 / 企業簡介</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;">
                <div style="text-align: center;display: inline-flex;">&nbsp;<img alt="" class="ccc_img" src="@/assets/1-1F30P10Q9242.jpg"  style="width: 100%; height: 160px;"></div>
                <br>
                <div style="text-align: left">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">本公司於二零零六年十月五日根據開曼群島法律註冊成立。本公司為一家投資控股公司。本集團是澳門銀河娛樂及娛樂場博彩設施的領先擁有者之一。本集團擁有兩項主要物業，澳門置地廣場及澳門漁人碼頭。澳門置地廣場為集合酒店、娛樂場及豪華購物中心的得獎綜合設施，特設五星級酒店及澳門首個主題娛樂場。澳門漁人碼頭為位於澳門半島外港並集合博彩、酒店、會議及娛樂的海濱綜合設施，符合中國澳門特別行政區的「消閒、旅遊、經濟及多元文化」政策。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">本公司及其附屬公司(“本集團”)的業務包括(i)根據服務協議於位於其物業的兩個主要娛樂場，即澳門置地廣場內的法老王宮殿娛樂場及位於澳門漁人碼頭的巴比倫娛樂場向澳博提供博彩服務；及(ii)經營其物業內的酒店、娛樂及休閒設施。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">澳門漁人碼頭的重建項目將可增加澳門漁人碼頭所提供的項目並可吸引更廣泛的客戶群。澳門漁人碼頭重建項目包括重建現有設施以及添置新設施，如勵庭海景酒店、勵宮酒店、金沙酒店、兩間新娛樂場、一般娛樂及文化設施、有蓋露天購物、美食及娛樂柱廊、位於遊艇碼頭的遊艇俱樂部以及其他景點等。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一二年五月十八日，本集團完成收購澳門漁人碼頭國際投資股份有限公司(“澳門漁人碼頭投資”)的全部股本權益。澳門漁人碼頭投資及其附屬公司(“澳門漁人碼頭集團”)主要從事經營澳門漁人碼頭。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一三年七月五日，本公司透過香港公開發售及國際配售之方式進行首次公開發售，按每股2.35港元發行934,827,000股新股份，相當於緊接全球發售完成後經擴大已發行股本的15%，以換取現金。自當日起，股份於香港聯合交易所有限公司(“聯交所”)主板上市。本公司自全球發售籌集所得款項淨額約21億港元。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一四年一月，本公司完成按每股股份7.25港元向若干獨立專業、機構及其他投資者先舊後新配售188,000,000股新股份（相當於完成先舊後新配售後本公司的經擴大已發行股本約2.92%），並募集所得款項淨額約1,350,800,000港元。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一四年四月八日，本集團與中國工商銀行(澳門)股份有限公司(“工銀澳門”)及其他貸款人就澳門漁人碼頭投資可用融資訂立金額42.21億港元的融資協議。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一四年七月三日，本集團於本公司股東特別大會上獲本公司獨立股東批准成立可變權益實體架構。可變權益實體架構讓本集團間接從事博彩中介業務，並對由新金沙於其物業內的娛樂場經營的貴賓房的管理及市場推廣擁有更大的控制權以及提高其市場覆蓋面，及提高收取該等貴賓房的賭枱產生的博彩收益總額的百分比。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一四年十月二十八日，本集團獲博監局告知向本公司授出35張額外賭枱。額外賭枱將提升本集團的博彩承載力及支持現時澳門漁人碼頭重建項目。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">勵庭海景酒店為澳門漁人碼頭重建項目的首家新酒店，於二零一五年二月二日開始試業，並於二零一五年二月十一日隆重開幕。勵庭海景酒店的設計乃仿照十八世紀布拉格建築風格，為澳門半島旅遊市場提供額外389間客房及55間套房。酒店與鄰近的巴比倫娛樂場之間以行人天橋連接。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;">於二零一五年七月二十二日，本公司與佛得角政府訂立協議，以約250,000,000歐元（相當於約2,150,000,000港元）的投資額，於聖地牙哥島普拉亞市（佛得角之首都）發展世界級之綜合休閒、旅遊及娛樂設施（「該項目」）。該項目之土地批給為期75年。本集團獲授聖地牙哥島之博彩批給為期25年（其中首15年為獨家批給）。此外，本集團亦獲准許於全國獨家經營網上博彩、實體及網上體育博彩業務，由本集團開始在佛得角經營網上博彩業務起計為期十年。</span>

                </div>
             </div>
            </div>

            <!-- 總裁致辭-->
            <div v-if="dialogVisible==2" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">關於 / 總裁致辭</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;">
                <div style="text-align: center;display: inline-flex;">&nbsp;<img alt="" class="ccc_img" src="@/assets/1-1F30P10Q9242.jpg" style="width: 100%;  height: 160px;"></div>
                <br>
                <div style="text-align: center;"><img alt="" src="@/assets/1-1F30QI000X7.jpg" style="width: 240px; height: 291px;"><br>
                  <strong class="subtitle" style="color: rgb(176, 154, 89); font-size: 14px; padding: 20px 0px 10px; font-family: Arial, Helvetica, sans-serif; line-height: 22px; text-align: justify; widows: 1;">行政總裁的話</strong></div>
                <p style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                  澳門半島匯聚多個歷史名勝和娛樂熱點，為旅客帶來最佳的景點和體驗，繼續展現出巨大的增長潛力。作為澳門領先的娛樂博彩及消閒設施擁有者之一，並持有兩個位於澳門半島中心地帶的物業，本公司已準備就緒，把握澳門市場持續增長所帶來的機遇。</p>
                <p style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                  我們堅持秉承澳門政府定立的發展目標，支持多元化景點發展。於二零一二年，我們的業務踏上了新的台階，與澳門漁人碼頭國際投資合併，成為澳門最大的休閒和娛樂中心 – 澳門漁人碼頭的擁有者。我們已經積極重建澳門漁人碼頭，翻新現有設施，並加入全新景點，以吸引來自亞洲至世界各地不同類型的旅客。澳門漁人碼頭將專注提供家庭及文化娛樂，並將成為澳門一個重要的新項目，及澳門半島一個極具吸引力的旅遊熱點。</p>
                <p style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                  在二零一二年的合併後，澳門博彩控股有限公司投資於本公司，顯示他們對本公司及澳門漁人碼頭重建項目，以及澳門半島的未來增長前景充滿信心。</p>
                <p style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                  本公司已於二零一三年七月五日在香港聯合交易所有限公司主板上市。</p>
                <p style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                  憑藉不懈的努力和堅定的決心，我們多元化的娛樂消閒事業將作出重大貢獻，幫助澳門由一個傳統博彩中心，轉變成全球的頂級旅遊目的地，以迎合各式各樣的訪客。</p>
                <p style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                  站在推動澳門旅遊業發展的前線，漁人碼頭在澳門的娛樂及消閒市場上定位為行業領導者之一我們於澳門的娛樂及消閒市場份額定將節節上升。</p>
                <span class="name" style="margin: 0px; padding: 0px; list-style: none; font-weight: bold; color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">爱德华·卓思</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">
                <m style="color: rgb(170, 170, 170); font-size: 11px; font-family: Arial, Helvetica, sans-serif; line-height: 22px; text-align: justify; widows: 1;">聯席主席、執行董事兼行政總裁</m>
              </div>
            </div>
            <!-- 關於 / 聯繫我們-->
            <div v-if="dialogVisible==3" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">關於 / 聯繫我們</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;">
                <div style="text-align: center;display: inline-flex;">&nbsp;<img alt="" class="ccc_img" src="@/assets/1-1F30P10Q9242.jpg" tppabs="/statics/caipiao/img/1-1F30P10Q9242.jpg" style="width: 100%;  height: 160px;"></div>
                <br>
                <table border="0" cellpadding="0" cellspacing="0" style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify;" width="100%">
                  <tbody>
                  <tr class="bodytext">
                    <td colspan="2" style="padding-bottom: 5px;" valign="top">
                      請於您的申請中註明職位編號及名稱並將資料發送至以下電郵地址：<br>
                      &nbsp;</td>
                  </tr>
                  <tr class="bodytext">
                    <td colspan="2" style="padding-bottom: 5px;" valign="top">
                      <b style="color: rgb(109, 91, 36);">公司地址；香港特別行政区中西区上环干诺道西3号亿利商业大厦
                      </b></td>
                  </tr>
                  <tr class="bodytext">
                    <td colspan="2" style="padding-bottom: 5px;" valign="top">
                      <b style="color: rgb(109, 91, 36);">
                        电话：85266398176</b></td>
                  </tr>
                  <tr class="bodytext">
                    <td colspan="2" style="padding-bottom: 5px;" valign="top">
                      <b style="color: rgb(109, 91, 36);">酒店部分</b></td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;" width="33%">
                      澳門置地酒店</td>
                    <td style="padding-bottom: 5px;" width="67%">
                      -<a href="mailto:career_lm@macaulegend.com" style="margin: 0px; padding: 0px; list-style: none; color: rgb(109, 91, 36); outline: none;">career_lm@macaulegend.com</a></td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;">
                      香港銷售辦事處</td>
                    <td style="padding-bottom: 5px;">
                      -<a href="mailto:hk.macaulegend@macaulegend.com" style="margin: 0px; padding: 0px; list-style: none; color: rgb(109, 91, 36); outline: none;">hk.macaulegend@macaulegend.com</a></td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;">
                      <br>
                      澳門漁人碼頭</td>
                    <td style="padding-bottom: 5px;">
                      &nbsp;</td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;">
                      萊斯酒店</td>
                    <td style="padding-bottom: 5px;">
                      -<a href="mailto:career_mfw@macaulegend.com" style="margin: 0px; padding: 0px; list-style: none; color: rgb(109, 91, 36); outline: none;">career_mfw@macaulegend.com</a></td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;">
                      君億集團</td>
                    <td style="padding-bottom: 5px;">
                      &nbsp;</td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;">
                      <br>
                      澳門勵庭海景酒店</td>
                    <td style="padding-bottom: 5px;">
                      <br>
                      -<a href="mailto:career_hvh@macaulegend.com" style="margin: 0px; padding: 0px; list-style: none; color: rgb(109, 91, 36); outline: none;">career_hvh@macaulegend.com</a></td>
                  </tr>
                  <tr>
                    <td colspan="2" height="18" style="padding-bottom: 5px;" valign="top">
                      &nbsp;</td>
                  </tr>
                  <tr class="bodytext">
                    <td colspan="2" style="padding-bottom: 5px;" valign="top">
                      <b style="color: rgb(109, 91, 36);">娛樂場部分</b></td>
                  </tr>
                  <tr class="bodytext">
                    <td style="padding-bottom: 5px;" width="33%">
                      巴比倫及法老皇娛樂場</td>
                    <td style="padding-bottom: 5px;" width="67%">
                      -<a href="mailto:career_gaming@macaulegend.com" style="margin: 0px; padding: 0px; list-style: none; color: rgb(109, 91, 36); outline: none;">career_gaming@macaulegend.com</a></td>
                  </tr>
                  </tbody>
                </table>				</div>
            </div> <!-- 彩種介紹 / 基本玩法-->

            <div v-if="dialogVisible==4" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">關於 / 董事會</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;">
                <div style="text-align: center;display: inline-flex;">&nbsp;<img alt="" class="ccc_img" src="@/assets/1-1F30P10Q9242.jpg"  style="width: 100%;  height: 160px;" /></div>
                <br>
                <div style="text-align: center;">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1;">董事會的責任是維護本集團所有利益相關者的長遠利益，職責包括監督管理層的表現，並以負責任的態度帶領本集團以行之有效及可持續的方式經營業務。</span></div>
                <div style="text-align: center;">
                  <span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;">執行董事</span><br>
                  &nbsp;</div>
                <div style="text-align: center;">
	<span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;">
	<img alt="" src="@/assets/1-1F30QI000X7.jpg"  style="width: 140px; height: 170px;" /></span><br>
                  <span class="name" style="margin: 0px; padding: 0px; list-style: none; font-weight: bold; color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">爱德华·卓思先生</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">聯席主席、執行董事兼行政總裁</span></div>
                <br>
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">爱德华·卓思先生為本集團聯席主席兼執行董事，同時身兼行政總裁一職。於創辦本集團的業務前，爱德华·卓思在博彩、博彩中介、娛樂及酒店行業已累積了超過三十年的經驗。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">爱德华·卓思現時為中國人民政治協商會議第十二屆全國委員會委員。爱德华·卓思於一九九六年、二零零一年及二零零五年獲選為澳門政府的議員，並於二零零四年，二零零九年及二零一四年出任澳門行政長官選舉委員會成員。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">爱德华·卓思於一九九八年及二零零一年分別創立了澳門旅遊零售服務業總商會及澳門旅遊業議會。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">於二零零七年，爱德华·卓思獲頒發二零零六年中國十大建設英才的榮譽，以表揚其於澳門旅遊業的經驗及作出的貢獻，並獲澳門政府頒發旅遊功績勳章，以表彰他對旅遊業的貢獻。</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">除本集團外，爱德华·卓思亦管理中國其他酒店業務。他自二零零八年起擔任北京華海金寶房地產開發有限公司的董事長，該公司自二零零七年起擁有及管理五星級獲獎酒店—北京金沙酒店。</span><br>
                <br>
                <div style="text-align: center;">
                  <img alt="" src="@/assets/1-1F30QJ62bK.jpg"  style="width: 140px; height: 170px;" /><br>
                  <span class="name" style="margin: 0px; padding: 0px; list-style: none; font-weight: bold; color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">林鳳娥女士</span><br style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">
                  <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);">執行董事兼副主席</span></div>
                <br>
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;">林鳳娥女士為本集團執行董事兼副主席，亦是澳門漁人碼頭投資有限公司的副主席。林女士於澳門博彩行業擁有超過三十年的經驗，並自一九八零年代為澳娛工作。&nbsp;</span><br style="line-height: 22px;">
<span style="line-height: 22px;">林女士分別於二零零四年及二零零九年擔任澳門行政長官選舉委員會成員。她在二零零九年獲澳門政府頒發文化功績勳章，並獲廣州人民代表大會頒授廣州市榮譽市民的殊榮。</span></span><br>
                <br>
                <div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;">
	<img alt="" src="@/assets/1-1F30QJG5500.jpg"  style="width: 140px; height: 170px;" /><br>
	<span class="name" style="margin: 0px; padding: 0px; list-style: none; font-weight: bold; color: rgb(176, 154, 89); line-height: 22px;">Sheldon Trainor - DeGirolamo先生</span><br style="line-height: 22px;">
	<span style="line-height: 22px;">執行董事</span></span></span></div>
                <br>
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;">Sheldon Trainor - DeGirolamo先生為本集團執行董事。Trainor先生於財務顧問服務方面擁有超過二十年的經驗，自一九九四年起獲證劵及期貨事務監察委員會發牌，於證券及期貨條例生效前為投資代表，及根據證券及期貨條例為代表，可進行第6類受規管活動（就機構融資提供意見）。&nbsp;</span><br style="line-height: 22px;">
<span style="line-height: 22px;">Trainor先生曾為數間著名的投資銀行服務，包括Credit Suisse Management (Australia) PTY Limited及Merrill Lynch，並為亞洲娛樂場、休閒及物業公司集資方面擁有豐富經驗。他亦曾任職摩根士丹利集團公司。他在二零零九年創立PacBridge Capital Partners (HK) Limited。</span></span></span></span><br>
                <br>
                <div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;">
<!--	<img alt="" src="@/assets/1-1F30QJK6496.jpg"  style="width: 140px; height: 170px;" />-->
	<img alt="" src="@/assets/1-1F30QJ910T6.jpg"  style="width: 140px; height: 170px;" />
    <br>
	<span class="name" style="margin: 0px; padding: 0px; list-style: none; font-weight: bold; color: rgb(176, 154, 89); line-height: 22px;">周宏學先生</span><br style="line-height: 22px;">
	<m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;">執行董事、企業發展總監及巴比倫娛樂場總監</m></span></span></span></span></div>
                <span style="color: rgb(51, 51, 51); font-family: Arial, Helvetica, sans-serif; font-size: 13px; line-height: 22px; text-align: justify; widows: 1; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;"><br>
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">周宏學先生自二零一六年九月一日起擔任為本集團的執行董事。主要負責執行企業諮詢及主要投資交易。</span><br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">周宏學先生於二零一三年七月加入本集團擔任企業財務分析師，並自二零一四年七月及二零一五年五月獲委任為本集團的企業發展總監及巴比倫娛樂場總監。他參與本集團新增及現有業務發展項目，並監督巴比倫娛樂場的博彩營運。他亦領導新娛樂場管理系統的安裝及執行及協助本集團的投資者關係。</span><br>
<br>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;">非執行董事</span></span><br>
	&nbsp;</div>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;">
	<img alt="" src="@/assets/1-1F30QJ910T6.jpg"  style="width: 140px; height: 170px;"><br>
	<span class="name" style="margin: 0px; padding: 0px; list-style: none; font-size: 13px; line-height: 22px;">唐家榮先生</span><br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">聯席主席兼非執行董事</span></span></span></div>
<br>
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;">唐家榮先生為本集團的聯席主席兼非執行董事。唐先生擁有豐富的業務管理經驗。他在一九八七年成立Carl Tong &amp; Associates Management Consultancy Limited。他亦為安利（香港）管理有限公司（為陳婉珍全資擁有的管理服務公司）的董事及行政總裁。唐先生於二零零三年至二零一三年一直擔任Creative Master Bermuda Limited的執行董事兼行政總裁，並於一九九七年至二零零零年間為Creative Master International Inc.的主席及行政總裁。他於二零零四年至二零一一年間出任豐德麗控股有限公司（聯交所股份代號：0571）的獨立非執行董事，以及於二零零七年至二零一二年間出任鱷魚恤有限公司（聯交所股份代號：0122）的董事。&nbsp;</span><br style="line-height: 22px;">
<span style="line-height: 22px;">此外，唐先生於一九八二年至一九八八年間為香港中西區區議會議員，並於一九八四年至一九八五年間成為香港立法局議員。</span></span></span></span><br>
<br>
<div style="text-align: center;">
	<img alt="" src="@/assets/1-1F412044I91Z.jpg" style="width: 140px; height: 176px;"></div>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span class="name" style="margin: 0px; padding: 0px; list-style: none; color: rgb(176, 154, 89); line-height: 22px;">何超蓮女士</span><br style="line-height: 22px;">
	<span style="line-height: 22px;">非執行董事</span></span></span></span></span></div>
<br>
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;">何超蓮女士自二零一六年九月一日起擔任為本集團的非執行董事。</span><br style="line-height: 22px;">
<span style="line-height: 22px;">何超蓮女士於二零一三年擔任倫敦安永會計師事務所之助理稅務顧問，並自二零一四年三月至二零一四年十月擔任北京安永會計師事務所之高級會計人員。她曾擔任UNIR Australia Pty Ltd 之董事。</span></span></span></span></span></span><br>
<br>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;">獨立非執行董事</span></span></span></span></span></span></span><br>
	&nbsp;</div>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;"><span class="name" style="margin: 0px; padding: 0px; list-style: none; font-size: 13px; line-height: 22px;">方中先生</span><br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">獨立非執行董事及審核委員會主席</span></span></span></span></span></span></span></span></div>
<br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">方中先生為本集團的獨立非執行董事及審核委員會主席。</span><br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">方先生於專業會計方面擁有接近三十年的經驗，自一九八六年三月成為香港會計師公會資深會員。他於二零零七年擔任香港會計師公會會長，並曾於二零一二年出任該會的審核委員會成員。&nbsp;</span><br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">方先生於二零零九年至二零一三年曾擔任均富國際有限公司的中國發展執行董事一職，並自二零零四年及二零一一年起分別出任中石化冠德控股有限公司（聯交所股份代號：0934）及新華人壽保險股份有限公司（聯交所股份代號：1336）的獨立非執行董事。 方先生亦為Worldsec Limited (LON: WSL)的非執行董事。</span></span></span></span></span></span></span></span><br>
<br>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span class="name" style="margin: 0px; padding: 0px; list-style: none; color: rgb(176, 154, 89); line-height: 22px;">謝岷先生</span><br style="line-height: 22px;">
	<span style="line-height: 22px;">獨立非執行董事及薪酬委員會主席</span></span></span></span></span></span></span></span></span></div>
<br style="line-height: 22px;">
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;">謝岷先生為本集團的獨立非執行董事及薪酬委員會主席。</span><br style="line-height: 22px;">
<span style="line-height: 22px;">謝先生於私募股權及併購方面擁有超過二十年經驗，曾於多間上市企業及國際私募股權基金及機構擔任高級職位。他於二零零一年至二零零四年間出任TOM.COM INTERNATIONAL LIMITED（TOM集團有限公司（聯交所股份代號：2383）的全資附屬公司）的首席投資官、於二零零四年至二零零六年間為中銀國際亞洲有限公司的董事總經理及私募股權部主管。他於二零零八年至二零一一年間為美國艾威資本香港有限公司香港代表辦事處的董事總經理。&nbsp;</span><br style="line-height: 22px;">
<span style="line-height: 22px;">謝先生現為携盛中國資本顧問有限公司的董事，及自二零一二年四月起為濤石能源投資基金的投資審核委員會副主席。謝先生為對外經濟貿易大學的客席教授及其董事會成員。謝先生亦自二零零九年起出任中國人民政治協商會議河南省委員會委員。</span></span></span></span></span></span></span></span></span><br>
<br>
<div style="text-align: center;">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span class="name" style="margin: 0px; padding: 0px; list-style: none; color: rgb(176, 154, 89); line-height: 22px;">譚惠珠女士<br>
	<img alt="" src="@/assets/1-1F4120502139C.jpg"  style="width: 140px; height: 170px;" /></span><br style="line-height: 22px;">
	<span style="line-height: 22px;">獨立非執行董事及提名委員會主席</span><br style="line-height: 22px;">
	<span style="line-height: 22px;">譚惠珠女士為本集團的獨立非執行董事及提名委員會主席。</span></span></span></span></span></span></span></span></span></span></div>
<br style="line-height: 22px;">
<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; font-weight: bold; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;"><span style="color: rgb(176, 154, 89); font-size: 14px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><span style="line-height: 22px;"><span style="line-height: 22px;">譚女士擁有超過四十年的執業大律師經驗。她自一九七三年起為英國一個專業大律師及法官協會格雷律師學院的委員，並分別於一九七二年及一九七四年於英國及香港取得律師資格。她自二零零六年起擔任香港和解中心的榮譽顧問。</span><br style="line-height: 22px;">
<span style="line-height: 22px;">譚女士於一九八二年、一九八四年及一九八八年獲英國政府委任為太平紳士，以及獲頒大英帝國官佐勳章(O.B.E)及大英帝國司令勳章(C.B.E)，及分別於一九九八年及二零一三年獲香港特別行政區政府頒授金紫荊星章及大紫荊勳章。</span><br style="line-height: 22px;">
<span style="line-height: 22px;">譚女士分別自一九九四年起於永安國際有限公司（聯交所股份代號：0289）、一九九七年起於五礦建設有限公司（聯交所股份代號：0230）、一九九八年起於中石化冠德控股有限公司（聯交所股份代號：0934）、一九九九年起於廣南（集團）有限公司（聯交所股份代號：1203）、二零零零年起於北京同仁堂科技發展股份有限公司（聯交所股份代號：1666）、二零零四年起於莎莎國際控股有限公司（聯交所股份代號：0178）、二零零六年起於玖龍紙業（控股）有限公司（聯交所股份代號：2689）及二零零四年至二零一二年間於泰山石化集團有限公司（聯交所股份代號：1192）擔任獨立非執行董事一職。</span></span></span></span></span></span></span></span></span></span></m></span></span></span></span>				</div>
            </div>

            <div v-if="dialogVisible==5" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">關於 / 高級管理層</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;">
                <div style="text-align: center;display: inline-flex;">&nbsp;<img alt="" class="ccc_img" src="@/assets/1-1F30P10Q9242.jpg"  style="width: 100%;  height: 160px;"></div>
                <br>
                <div style="text-align: center;">
                  &nbsp;<br>
                  <span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;">高級管理層</span><br>
                  &nbsp;</div>
                <div style="text-align: center;">
                  &nbsp;</div>
                <div style="text-align: center;">
	<span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span class="name" style="margin: 0px; padding: 0px; list-style: none; font-size: 13px; line-height: 22px; text-align: justify; background-color: rgb(246, 246, 246);">王萬祥先生</span><br style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; text-align: justify; background-color: rgb(246, 246, 246);">
	<span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; text-align: justify; background-color: rgb(246, 246, 246);">執行副總裁，首席財務總監及公司秘書</span></span><br>
                  &nbsp;</div>
                <span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);">王萬祥先生為本公司執行副總裁，首席財務總監及公司秘書。王先生主要於會計、審計、企業融資、庫務、商業及財務監控、財務顧問及企業管治方面擁有逾20年工作經驗。他曾參與廣泛的業務，包括但不限於物業發展及投資、建築、工程、貿易、製造、電訊、礦業、經銷及零售。他為香港會計師公會會員，及曾為特許公認會計師公會資深會員。於加入本集團前，王先生分別於香港的上市及非上市集團中擔任多個高級職位。王先生主要負責管理集團的財務及合規事務。</span></span><br>
                <br>
                <div style="text-align: center;">
	<span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);">
	<img alt="" src="@/assets/1-1F30QKA3T3.jpg"  style="width: 140px; height: 170px;"><br>
	<span class="name" style="margin: 0px; padding: 0px; list-style: none; color: rgb(176, 154, 89); line-height: 22px;">葉榮發先生</span><br style="line-height: 22px;">
	<span style="line-height: 22px;">執行副總裁，娛樂場營運主管</span></span></span><br>
                  &nbsp;</div>
                <div>
                  <span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;">葉榮發先生為本集團的執行副總裁，娛樂場營運主管。葉先生於澳門博彩業擁有超過二十年的工作經驗。他在一九九七年加入本集團。葉先生自二零一二年起出任澳門旅遊發展委員會代表及自二零零九年起為中國人民政治協商會議湖北省委員會委員。</span></span></span></span><br>
                  &nbsp;</div>
                <div style="text-align: center;">
	<span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;">
	<img alt="" src="@/assets/1-1F30QKI44T.jpg"  style="width: 140px; height: 170px;"><br>
	<span class="name" style="margin: 0px; padding: 0px; list-style: none; color: rgb(176, 154, 89); line-height: 22px;">Hans - Peter Betz 先生</span><br style="line-height: 22px;">
	<m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;">勵庭海景酒店總經理</m></span></span></span></span><br>
                  &nbsp;</div>
                <div>
                  <span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;"><m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">Hans-Peter Betz先生於二零一四年三月獲委任為勵庭海景酒店總經理。 Betz先生從烹飪界開始發展其事業，並獲取德國廚師文憑。後來，他亦取得歐洲及德國管理文憑。他曾在美國、加勒比海、歐洲、泰國、中國、南韓和沙地阿拉伯工作。於二零零九年至二零一四年間，他在中國和南韓管理及開設五家新酒店。Betz先生負責勵庭海景酒店的日常營運管理。</span></m></span></span></span></span><br>
                  &nbsp;</div>
                <div style="text-align: center;">
	<span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;"><m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">
	<img alt="" src="@/assets/1-1F30QKRM51.jpg" style="width: 140px; height: 170px;"><br>
	<span class="name" style="margin: 0px; padding: 0px; list-style: none; color: rgb(176, 154, 89); line-height: 22px;">楊家明先生</span><br style="line-height: 22px;">
	<m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;">勵宮酒店總經理</m></span></m></span></span></span></span><br>
                  &nbsp;</div>
                <div>
                  <span style="color: rgb(176, 154, 89); font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: bold; line-height: 22px; text-align: justify; widows: 1;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px; background-color: rgb(246, 246, 246);"><span style="line-height: 22px;"><span style="line-height: 22px;"><m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;"><m style="color: rgb(170, 170, 170); font-size: 11px; line-height: 22px;"><span style="color: rgb(51, 51, 51); font-size: 13px; line-height: 22px;">楊家明先生為勵宮酒店總經理。楊先生於二零一六年二月加入本集團。他於酒店行業累積超過三十年的經驗，遍及澳門、香港和中國大陸。在二零一六年二月加入本集團之前，楊先生於二零一二年至二零一六年間擔任中國惠州洲際度假酒店總經理及於二零一一年至二零一二年間擔任中國九龍湖公主酒店總經理。楊先生負責勵宮酒店的日常營運。</span></m></span></m></span></span></span></span></div>
              </div>            </div>
          </div>
        </el-col>
      </el-row>


      <footer>
        <div class="foot_con pub_case pure">
          <div class="link_foo">
            <a href="" target="_blank">聯繫我們</a> |
            <a href="" target="_blank">反饋意見</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">免責聲明</a> |
            <a href="" target="_blank">網頁指南</a> |
          </div>
          <div class="copyRight at_on">
            @2011 澳門銀河娛樂有限公司版權所有 不得轉載
          </div>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>

import HeaderContainer from "@/components/HeaderContainer.vue";

export default {
  name: 'CompanyProfile',
  components: {HeaderContainer},
  data() {
    return {
      currentMenuIndex: '5', // 根据当前路由设置: 1,
      dialogVisible:1,
      title:"企業簡介"
    }
  },
  created() {

  },
  methods: {    /*主键函数*/
    onMenuSelect(index, indexPath) {
      console.log('选中菜单:', index, indexPath)
    },

    showFun(type,title){
      this.dialogVisible=type
      this.title=title
    },
    hrefUrl(url) {
      window.location.href = url;
    },
    routerUrl(url) {
      this.$router.replace(url);
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  padding: 0;
  justify-items: center;
  overflow-y: auto;
}

.contentDiv {
  padding: 0;
  background: rgb(4, 23, 65);
  /*background-image: url("../assets/bgvideo.webp");*/
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  align-items: center; /*定义父元素的元素垂直居中*/
  justify-content: center; /*定义子元素的里的元素水平居中*/
  text-align: center;
}



.horizontal-nav li {
//margin: 0 15px; //padding: 8px 16px; color: white;
  border-radius: 4px;
}


.responsive-left, .responsive-right {
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}


.responsive-left {
  text-align: left;
}



/**
  左侧
 */
.mybox {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 0px;
  margin: 0px;
}

.mybox .mybox_title {
  background-color: #2b3e68;
  height: 32px;
  border-bottom: 0px solid rgb(43, 61, 97);
}

.mybox .mybox_title div .title {
  font-size: 14px;
  font-weight: bold;
  color: rgb(254, 208, 1);
  padding: 8px;
}

.mybox .mybox_content {
  color: rgb(201, 226, 238);
}

ul {
  list-style-type: none;
  border-bottom: 1px solid rgb(43, 61, 97);
}

ul, ol, dl {
  line-height: 1.5em;
  margin: 0px;
  padding: 0px;
}

#help_box .mybox_content li.top {
  padding-left: 20px;
}

.mybox_content li a:hover {
  color: rgb(254, 208, 1);
  cursor: pointer;
}

#help_box .top {
  font-weight: bold;
  background: rgb(29, 44, 81);
  border-bottom: 1px solid rgb(43, 61, 97);
  font-size: 14px;
  line-height: 25px;
}

#help_box .mybox_content li.top a {
  display: block;
}

.mybox .mybox_content a {
  color: rgb(255, 255, 255);
}

/**
右侧
 */

/**
简介
 */
.dbox {
  background: rgb(255, 255, 255);
}

.mybox {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 0px;
  margin: 0px;
}

.mybox .mybox_title {
  background: rgb(29, 44, 81);
  height: 32px;
  border-bottom: 0px solid rgb(43, 61, 97);
}

.subcolumns {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.mybox .mybox_title div .title {
  font-size: 14px;
  font-weight: bold;
  color: rgb(254, 208, 1);
  padding: 8px;
  text-align: left;
}

/**
获奖资格
 */
.content {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 6px;
  margin: 0px;
}
.mainTable {
  text-align: left;
}
.mainTable tr td{
  padding: 0.5em;
}
.content {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 6px;
  margin: 0px;
}

/**
页脚
 */
footer .foot_con {
  padding: 15px 0;
  color: #4e6692;
  font-size: 12px;
}

.pub_case {
  margin-left: auto;
  margin-right: auto;
}

footer .link_foo {
  float: right;
}

footer .copyRight {
  float: left;
}

footer .foot_con a {
  color: #4e6692;
}
@media (max-width:500px) {

  .link_foo{
    font-size: 4px;
  }

  .copyRight{
    font-size: 4px;
  }

  .bbbb{
    width: 20rem;
  }
  .logo111{
    position: absolute;
    margin-top: 14px !important;
    width: 100px;
  }

  .ccc_img{
    width: 340px !important;
    height: 160px !important;
  }
  .el-row{
    width: auto !important;
  }
}


</style>

